var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMgsHeadline)?_c('Headline',{attrs:{"type":_vm.type,"weight":_vm.weight,"backgroundColor":_vm.backgroundColor}},[_vm._t("default")],2):_c('div',[_c('div',{class:_vm.aufbauplusHeadlineClasses},[_c(_vm.aufbauplusHComponent,{tag:"component",class:_vm.aufbauplusHeadingClass},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }